import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";

const PageScroller = ({ children }) => {
    const { pathname, hash, search } = useLocation();
    const routeParams = useParams();
    const [previousLocation, setPreviousLocation] = useState({});

    useEffect(() => {
        // Extract the base path without query parameters
        const basePath = pathname.split("?")[0];
        const previousBasePath = previousLocation.pathname?.split("?")[0];

        // Check if we're on an agent page
        const isAgentPage = pathname.includes("/agents/");
        const wasAgentPage = previousLocation.pathname?.includes("/agents/");

        // Determine if we should scroll to top
        const shouldScrollToTop =
            // Always scroll when navigating to a new page (different base path)
            (basePath !== previousBasePath ||
                // Don't scroll when just changing query params within the same agent page
                !isAgentPage ||
                (isAgentPage && !wasAgentPage)) &&
            !hash;

        if (
            typeof window !== "undefined" &&
            window !== null &&
            shouldScrollToTop
        ) {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 3);
        }

        setPreviousLocation({ pathname, hash, routeParams, search });
        // eslint-disable-next-line
    }, [routeParams, pathname, search]);
    return <>{children}</>;
};

export default PageScroller;
